export default Object.freeze([
    {
        id: 1,
        portugueseName: 'Medicamentos Sistêmicos',
        ptShortName: 'Sistêmicos',
        name: 'Drugs',
        collection: 'drugs',
        productsCollection: 'veterinary_products',
        vaccines_suplements_serums: false,
        human_products: true,
        openSectionMethod: "openDrugs",
        openItemById: "openDrugsById",
        openProductById: "openDrugsProductsById",
    },
    {
        id: 2,
        portugueseName: 'Vacinas e Biológicos',
        ptShortName: 'Vacinas',
        name: 'Vaccines',
        collection: 'vaccines',
        productsCollection: 'vaccines_products',
        vaccines_suplements_serums: true,
        human_products: false,
        hideBrandSelection: true,
        openSectionMethod: "openVaccines",
        openItemById: "openVaccinesById",
        openProductById: "openVaccinesProductsById",
    },
    {
        id: 3,
        portugueseName: 'Higiene Oral',
        name: 'Oral Hygiene',
        collection: 'oral_hygiene',
        productsCollection: 'oral_hygiene_products',
        vaccines_suplements_serums: false,
        human_products: false,
        hideBrandSelection: true,
        openSectionMethod: "openOralHygiene",
        openItemById: "openOralHygieneById",
        openProductById: "openOralHygieneProductsById",
    },
    {
        id: 4,
        portugueseName: 'Dermatológicos Tópicos',
        ptShortName: 'Dermatológicos',
        name: 'Dermatological Topics',
        collection: 'dermatological_topics',
        productsCollection: 'dermatological_topics_products',
        vaccines_suplements_serums: false,
        human_products: false,
        hideBrandSelection: false,
        openSectionMethod: "openDermatologicalTopics",
        openItemById: "openDermatologicalTopicsById",
        openProductById: "openDermatologicalTopicsProductsById",
    },
    {
        id: 5,
        portugueseName: 'Agentes Oftalmológicos',
        ptShortName: 'Oftalmológicos',
        name: 'Agents Ophtalmic',
        collection: 'ophtalmic',
        productsCollection: 'ophtalmic_products',
        vaccines_suplements_serums: false,
        human_products: true,
        hideBrandSelection: true,
        openSectionMethod: "openOphtalmic",
        openItemById: "openOphtalmicById",
        openProductById: "openOphtalmicProductsById",
    },
    {
        id: 6,
        portugueseName: 'Suplementos',
        name: 'Supplements',
        collection: 'supplements',
        productsCollection: 'supplements_products',
        vaccines_suplements_serums: true,
        human_products: false,
        openSectionMethod: "openSupplements",
        openItemById: "openSupplementsById",
        openProductById: "openSupplementsProductsById",
        hideBrandSelection: true,
        orderByPhotos: true,
    },
    {
        id: 7,
        portugueseName: 'Calculadoras',
        name: 'Calculators',
        collection: 'calculators',
        productsCollection: 'calculators_products',
        orderByClasses: true,
        hideBrandSelection: true,
        openSectionMethod: "openCalculators",
        openItemById: "openCalculatorById",
    },
    {
        id: 8,
        portugueseName: 'Alimentos Prescritos e Coadjuvantes',
        name: 'Prescriptive and Supporting Foods',
        collection: 'supporting_food',
        productsCollection: 'supporting_food_products',
        foods: true,
        vaccines_suplements_serums: true,
        human_products: false,
        openSectionMethod: "openSupportingFood",
        openItemById: "openSupportingFoodById",
        openProductById: "openSupportingFoodProductsById",
        hideBrandSelection: true,
        orderByPhotos: true,
    },
    {
        id: 9,
        portugueseName: 'Alimentos Completos',
        name: 'Complete Food',
        collection: 'complete_food',
        productsCollection: 'complete_food_products',
        foods: true,
        vaccines_suplements_serums: true,
        human_products: false,
        openSectionMethod: "openCompleteFood",
        openItemById: "openCompleteFoodById",
        openProductById: "openCompleteFoodProductsById",
        hideBrandSelection: true,
        orderByPhotos: true,
    },
    {
        id: 10,
        portugueseName: 'Pestiscos e Snacks',
        name: 'Snacks',
        collection: 'snacks',
        productsCollection: 'snacks_products',
        foods: true,
        vaccines_suplements_serums: true,
        human_products: false,
        orderByPhotos: true,
    },
    {
        id: 11,
        portugueseName: 'Doenças',
        name: 'Diseases',
    },
    {
        id: 12,
        portugueseName: 'Tratamento',
        name: 'Treatment',
    },
    {
        id: 13,
        portugueseName: 'Patologia Clínica',
        name: 'Clinical Patology',
    },
    {
        id: 14,
        portugueseName: 'Algoritmos',
        name: 'Algorithms',
    },
    {
        id: 15,
        portugueseName: 'Folhetos do Tutor',
        name: 'Clinical Handouts',
    },
]);